<template>
  <div id="app">
    <a-layout style="height: 100%">
      <a-layout-header
        style="position: fixed; z-index: 2; width: 100%; min-width: 50rem"
        v-if="showHead"
      >
        <a-row type="flex" justify="space-between">
          <a-col>
            <a-menu
              theme="dark"
              mode="horizontal"
              v-model="selectedKeys"
              :style="{ lineHeight: '64px', fontSize: '1.2rem' }"
              @select="onSelect"
            >
              <a-menu-item key="instances"> 计算 </a-menu-item>
              <a-menu-item key="algorithms"> 训练 </a-menu-item>
              <a-menu-item key="myInstances"> 我的实例 </a-menu-item>
              <a-menu-item key="myCalc"> 计算记录 </a-menu-item>
              <a-menu-item key="help"> 文档 </a-menu-item>
            </a-menu>
          </a-col>
          <a-col>
            <a-popover trigger="hover" placement="bottom">
              <template slot="content">
                <p>
                  <a-button type="link" @click="goSetting"
                    ><a-icon type="setting" />设置</a-button
                  >
                </p>
                <p v-if="$store.state.isAdmin">
                  <a-button type="link" @click="goAdmin"
                    ><a-icon type="setting" />管理员</a-button
                  >
                </p>
                <p>
                  <a-button type="link" @click="logout"
                    ><a-icon type="logout" />登出</a-button
                  >
                </p>
              </template>
              <span class="hello uname">你好,</span>
              <span class="uname"> {{ getUname() }}</span>
              <!-- <a-avatar style="backgroundcolor: #87d068" icon="user" /> -->
            </a-popover>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout-content style="margin-top: 84px; height: 100%">
        <router-view></router-view>
      </a-layout-content>
    </a-layout>
  </div>
</template>
<script>
const notShowHead = ['login', 'forgetPwd']
export default {
  name: 'app',
  data() {
    return {
      showHead: ['login', ''].indexOf(this.$route.path.split('/')[1]) === -1,
      selectedKeys: ['']
    }
  },
  methods: {
    onSelect(info) {
      if (info.key === 'help') {
        this.$router.push('/help/index.html')
      } else {
        this.$router.push('/' + info.key)
      }
    },
    logout() {
      localStorage.setItem('accessToken', '')
      this.$http.defaults.headers.common.Authorization = ''
      this.$router.push('/login')
    },
    goSetting() {
      this.$router.push('/setting/changePwd')
    },
    goAdmin() {
      this.$router.push('/admin')
    },
    getUname() {
      return localStorage.getItem('uname')
    }
  },
  watch: {
    $route(to, from) {
      this.showHead = notShowHead.indexOf(to.path.split('/')[1]) === -1
      this.selectedKeys = [to.path.split('/')[1]]
    }
  },
  mounted() {
    this.selectedKeys = [this.$route.path.split('/')[1]]
  }
}
</script>

<style lang="less" scoped>
.hello {
  font-weight: 200;
}
.uname {
  color: lightgray;
  font-size: 1.2rem;
}

</style>
